<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4 d-flex justify-content-between">
				<h1 class="h3 mb-0 text-gray-800">
					Categorias de Despesas
				</h1>
				<div class="noprint">
					<button 
						class="btn btn-primary"
						@click="create()">
						Novo
					</button>
					<button 
				    	@click="$router.go(-1)" 
				    	class="btn btn-secondary">
			        	Voltar
			        </button>
				</div>
			</div>
			<div class="card">
                <div class="card-header">
		        	<div class="d-flex justify-content-between container-fluid">
			            <div class="text-muted fs-19">
			            	<strong>Registros</strong>
			            </div>
				    </div>
		        </div>
		        <div class="card-body">
		            <categoria-table
		            	link="/api/adm/categ-despesas/data"
		            	:key="categTableKey"
		            	@update="update"
		            	@destroy="destroy">
		            </categoria-table>
		        </div>
		    </div>
		</div>
		<categoria-create
			link="/api/adm/categ-despesas/store"
			@reload="reload">
		</categoria-create>
		<categoria-update
			link="api/adm/categ-despesas"
			:dado_id="dado_id"
			@reload="reload">
		</categoria-update>
		<bsh-confirm 
        	modal_id="confirm_destroy_categoria" 
        	:dado_id="dado_id" 
        	title="Deseja realmente excluir esta categoria?" 
        	btn="Excluir" 
        	btnStyle="btn-danger" 
        	method="delete" 
        	:rota="$url+'/api/adm/categ-despesas/destroy/'" 
        	@reload="reload">
        </bsh-confirm>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dado_id: 0,
				categTableKey: 0
			}
		},
		methods: {
			create(){
				$('#create_categoria').modal('show');
			},
			update(id){
				this.dado_id = id;
				$('#update_categoria').modal('show');
			},
			destroy(id){
				this.dado_id = id;
				$('#confirm_destroy_categoria').modal('show');
			},
			reload(){
				this.categTableKey += 1;
			}
		}
	}
</script>